import { AdSet } from './ad-set';
import { AdSlotConstraint } from './ad-slot-constraint';
import { AdSlotContainer } from './ad-slot-container';
import { AdSlotSettings } from './ad-slot-settings';
import { CreativeTypeEnum } from '../dto/recs.dto';

export class AdSlot {
  private readonly id?: string;
  private readonly creativeType?: CreativeTypeEnum;
  private adSet?: AdSet;
  private settings?: AdSlotSettings;
  private readonly containers: Set<AdSlotContainer> = new Set();
  private readonly constraints: Set<AdSlotConstraint> = new Set();

  public getId (): string {
    if (typeof this.id === 'undefined') {
      throw new Error(`Attempt to access "id" of ${this.constructor.name} before initialization`);
    }

    return this.id;
  }

  public getAdSet (): AdSet | null {
    return this.adSet ?? null;
  }

  public setAdSet (adSet?: AdSet): this {
    this.adSet = adSet;
    return this;
  }

  public getContainers (): AdSlotContainer[] {
    return [ ...this.containers.values() ];
  }

  public addContainer (container: AdSlotContainer): this {
    if (!this.containers.has(container)) {
      this.containers.add(container);
      container.setAdSlot(this);
      container.setIndex(this.containers.size - 1);
    }
    return this;
  }

  public removeContainer (container: AdSlotContainer): this {
    if (!this.hasContainer(container)) {
      return this;
    }

    if (this.containers.delete(container) && container.getAdSlot() === this) {
      container.setAdSlot(undefined);
    }

    return this;
  }

  public hasContainer (container: AdSlotContainer): boolean {
    return this.containers.has(container);
  }

  public getCreativeType (): CreativeTypeEnum {
    if (typeof this.creativeType === 'undefined') {
      throw new Error(`Attempt to access "creativeType" of ${this.constructor.name} before initialization`);
    }

    return this.creativeType;
  }

  public getSettings (): AdSlotSettings {
    if (typeof this.settings === 'undefined') {
      throw new Error(`Attempt to access "settings" of ${this.constructor.name} before initialization`);
    }

    return this.settings;
  }

  public setSettings (settings: AdSlotSettings): this {
    this.settings = settings;
    settings.setAdSlot(this);
    return this;
  }

  public getConstraints (): AdSlotConstraint[] {
    return [ ...this.constraints ];
  }

  public addConstraint (constraint: AdSlotConstraint): this {
    if (!this.constraints.has(constraint)) {
      this.constraints.add(constraint);
      constraint.setAdSlot(this);
    }
    return this;
  }

  public removeConstraint (constraint: AdSlotConstraint): this {
    if (!this.hasConstraint(constraint)) {
      return this;
    }

    if (this.constraints.delete(constraint) && constraint.getAdSlot() === this) {
      constraint.setAdSlot(undefined);
    }

    return this;
  }

  public hasConstraint (constraint: AdSlotConstraint): boolean {
    return this.constraints.has(constraint);
  }
}
